import {  Box, Backdrop, CircularProgress } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import QuotaDefinitionApproval from "./QuotaDefinitionApproval";
import NormalModification from "./NormalModification";
import ShiftModification from "./ShiftModification";
import CollapseSection from "../../../components/ui/CollapseSection";
import axios from "axios";
import { centralAdminUrls } from "../centralAdminUtils";

export default function ApprovalLevels() {
  const dispatch = useDispatch();
  const [shiftRows, setShiftRows] = useState([]);
  const [normalRows, setNormalRows] = useState([]);
  const [definitionRows, setDefinitionRows] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const baseUrl = centralAdminUrls.getScenarioCriticality;
  const autherization = localStorage.getItem("data");
  const data = JSON.parse(autherization);
  const token = data.token;

  useEffect(() => {
    setIsLoading(true);
    axios
      .get(baseUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const shftData = response.data.shftModificationLst;
        const normalData = response.data.nrmlModificationLst;
        const quotaData = response.data.mngQuotaLst;

        const transformData = (data) =>
          data.map(({ criticalityId, criticalityName, permissionValues }) =>
            permissionValues.reduce(
              (acc, { key, value }) => {
                acc[`key${key}`] = value;
                return acc;
              },
              { criticalityId, criticalityName }
            )
          );

        setShiftRows(transformData(shftData));
        setNormalRows(transformData(normalData));
        setDefinitionRows(transformData(quotaData));
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [baseUrl]);

  return (
    <>
      {isLoading && (
        <Box>
          <Backdrop
            sx={{
              color: "#fff",
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={isLoading}
          >
            <CircularProgress />
          </Backdrop>
        </Box>
      )}

      {!isLoading && (
        <>
          <CollapseSection title="Manage Quota Definition Approvals">
            <br />
            <QuotaDefinitionApproval
              definitionRows={definitionRows}
              setDefinitionRows={setDefinitionRows}
            />
          </CollapseSection>
          <CollapseSection title="Quota Modification Approvals">
            <br />
            <NormalModification
              normalRows={normalRows}
              setNormalRows={setNormalRows}
            />
            <ShiftModification shiftRows={shiftRows} setShiftRows={setShiftRows} />
          </CollapseSection>
        </>
      )}
    </>
  );
}
